/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ISHONCH Platform API
 * Login: POST /api/v1/auth/otp → code (dev: in the app log) → POST /api/v1/auth/otp/verify → paste response_data.as_access_token into Authorize. Every response is the company envelope (ADR-0007).
 * OpenAPI spec version: v1
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CabinetAttentionResponse } from "../iSHONCHPlatformAPI.schemas";

import { httpRequest } from "../../http";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCabinetAttentionUrl = () => {
  return `/api/v1/cabinet/attention`;
};

export const cabinetAttention = async (
  options?: Parameters<typeof httpRequest>[1],
): Promise<CabinetAttentionResponse> => {
  return httpRequest<CabinetAttentionResponse>(getCabinetAttentionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getCabinetAttentionQueryKey = () => {
  return [`/api/v1/cabinet/attention`] as const;
};

export const getCabinetAttentionQueryOptions = <
  TData = Awaited<ReturnType<typeof cabinetAttention>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cabinetAttention>>, TError, TData>>;
  request?: SecondParameter<typeof httpRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCabinetAttentionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cabinetAttention>>> = ({ signal }) =>
    cabinetAttention({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cabinetAttention>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CabinetAttentionQueryResult = NonNullable<Awaited<ReturnType<typeof cabinetAttention>>>;
export type CabinetAttentionQueryError = unknown;

export function useCabinetAttention<
  TData = Awaited<ReturnType<typeof cabinetAttention>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof cabinetAttention>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cabinetAttention>>,
          TError,
          Awaited<ReturnType<typeof cabinetAttention>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCabinetAttention<
  TData = Awaited<ReturnType<typeof cabinetAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cabinetAttention>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cabinetAttention>>,
          TError,
          Awaited<ReturnType<typeof cabinetAttention>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCabinetAttention<
  TData = Awaited<ReturnType<typeof cabinetAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cabinetAttention>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useCabinetAttention<
  TData = Awaited<ReturnType<typeof cabinetAttention>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cabinetAttention>>, TError, TData>>;
    request?: SecondParameter<typeof httpRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCabinetAttentionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
